import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ONLINESTATUS } from '../../../utils/questionManageType'

import axios from 'axios'
import API  from '../../../API/api';
import {Breadcrumb,  Button,  Input, Tag, Row, Col, Icon ,message,Modal,Alert,Upload,Spin,Tree,Popconfirm,Radio,Tooltip,Checkbox} from 'antd';
import {PropTypes} from 'prop-types';
import storage from '../../../utils/cookie'
import KnowledgeBox from '../../../entry_app/question_manage/set_tag/question_tag_detail/knowledge_box/view'

const TreeNode = Tree.TreeNode;
const RadioGroup = Radio.Group
const RadioButton = Radio.Button;
class DailyError extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    state = {
        search:'',
        treeData:[],

        mark:'',
        name:'',
        knowType:'0',
        allow_repeat_question:'0',
        knowDetail:{},
        visibleAdd:false,
        visibleEdit:false,
        visibleDetail:false,
        addId:'',
        editId:'',
        expandedKeys:[],
        autoExpandParent: true,
        matchingSearch:new Set(),
        loading:false,
        select:[
            {
                "type": 21,
                "title": "知识点",
                "pre_type": 0,
                "selected": []
            }
        ],
    }
    treeNode=[]
    componentDidMount(){
        this.getTreeData()
    }
    shouldComponentUpdate(nextProps,nextState){
        if(
            (nextState.treeData&&(nextState.treeData!==this.state.treeData))//树结构改变
            ||(nextState.matchingSearch!==this.state.matchingSearch)//搜素选中的项改变
        ){
            this.treeNode=this.loopDom(nextState.treeData,nextState)
        }
        return true;
    }

    refresh=()=>{
        this.getTreeData()
    }
    getTreeData=()=>{
        this.setState({loading:true})
        let data = {}
        axios.post(API.FRAMEEWORK_KNOWLEDGE_TREE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({treeData:res.data.list})
                this.setState({loading:false})
            }else{
                message.error(res.message)
                this.setState({loading:false})
            }
        },()=>{
            message.error("网络错误！");
            this.setState({loading:false})
        })
    }
    handleDownload = () => {
        const token = storage.getData('token');
        const { subject, grade_part } = this.props.user;
        window.location.href = `${API.FRAMEEWORK_KNOWLEDGE_DOWNLOAD}&token=${token}&subject=${subject}&grade_part=${grade_part}`;
    }


    handleDownloadTemp = () => {
        const token = storage.getData('token');
        const { subject, grade_part } = this.props.user;
        window.location.href = `${API.FRAMEEWORK_KNOWLEDGE_DOWNLOAD_FORMAT}&token=${token}&subject=${subject}&grade_part=${grade_part}`;
    }


    addKnow=(e,item)=>{
        e.stopPropagation();
        if(item.pre_list&&item.pre_list.length>0){
            return message.error('此知识点拥有前置知识点，不可添加子知识点，请清除前置知识点后再试。')
        }
        let isEndNode = true;
        if(!(item.list && item.list.length)){
            isEndNode = true
        }
        this.setState({visibleAdd:true,addKnowType:item.type,addId:item.id,name:'',mark:'',knowType:'0',allow_repeat_question:'0',isEndNode, select:[{"type": 21, "title": "知识点", "pre_type": 0, "selected": []}]})
    }
    //增加知识点
    addKnowledge=()=>{
        let data = {
            parent_id:this.state.addId,
            name:this.state.name,
            mark:this.state.mark,
            know_type:this.state.knowType,
            allow_repeat_question:''+this.state.allow_repeat_question,
            subject:this.props.user.subject,
            grade_part:this.props.user.grade_part
        }
        if(this.props.user.product){
            data.is_add = 1
            data.pre_know = this.state.select[0].selected.map(d=>({id:d.id,name:d.name}) )
        }
        axios.post(API.FRAMEEWORK_KNOWLEDGE_ADD, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('添加成功')

                let treeData = [...this.state.treeData]
                this.loop(treeData, this.state.addId, (item) => {
                    item.list = item.list || [];
                    // where to insert 示例添加到尾部，可以是随意位置
                    res.data.id = ''+res.data.id
                    res.data.online_status = ''+res.data.online_status
                    res.data.parent_id = ''+res.data.parent_id
                    if(res.data.pre_know){
                        res.data.pre_list = []
                        res.data.pre_know.forEach(d=>{
                            res.data.pre_list.push({pre_know_id:d.id,pre_name:d.name})
                        })
                    }
                    item.list.push(res.data);
                });
                let expandedKeys = this.state.expandedKeys
                expandedKeys.push(''+res.data.id)
                expandedKeys.push(''+this.state.addId)

                this.setState({visibleAdd:false,treeData:treeData,expandedKeys})
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //编辑知识点
    openKnowEdit=(e,item)=>{
        e.stopPropagation();
        let isEndNode = true;
        if(!(item.list && item.list.length)){
            isEndNode = true
        }
        let selected = []
        if(item.pre_list){
           item.pre_list.forEach(d=>{
               selected.push({name:d.pre_name,id:d.pre_know_id})
           })
        }
        this.detailKnowledge(item.id,()=>{
            this.setState({visibleEdit:true,editKnowType:item.type,editId:item.id,visibleDetail:false,isEndNode, select:[{"type": 21, "title": "知识点", "pre_type": 0, "selected": selected}]})
        })
    }
    editKnowledge=()=>{
        let data = {
            know_id:this.state.editId,
            name:this.state.name,
            mark:this.state.mark,
            allow_repeat_question:''+this.state.allow_repeat_question,
        }
        if(this.props.user.product){
            data.is_add = 0
            data.pre_know = this.state.select[0].selected.map(d=>({id:d.id,name:d.name}))
        }
        axios.post(API.FRAMEEWORK_KNOWLEDGE_EDIT, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('编辑成功')
                let treeData = [...this.state.treeData]
                this.loop(treeData, this.state.editId, (item) => {
                    item.name = this.state.name
                    item.mark = this.state.mark
                    if(res.data.pre_know){
                        item.pre_list = []
                        res.data.pre_know.forEach(d=>{
                            item.pre_list.push({pre_know_id:d.id,pre_name:d.name})
                        })
                    }
                });
                this.setState({visibleEdit:false,treeData:treeData})
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //上线知识点
    onlineKnowledge=(item,list)=>{
        let data = {
            know_id:item.id,
        }
        axios.post(API.FRAMEEWORK_KNOWLEDGE_ONLINE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('成功 次日生效')
                item.online_status = '1'
                const loop = (data,  callback) => {
                    data.forEach((item, index, arr) => {
                        callback(item, index, arr);
                        if (item.list) {
                            return loop(item.list,  callback);
                        }
                    });
                };
                if(item.list){
                    loop(item.list, (item1) => {
                        item1.online_status = '1'
                    });
                }
                let treeData = [...this.state.treeData]
                this.setState({treeData:treeData})
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //下线知识点
    offlineKnowledge=(item,list)=>{
        let data = {
            know_id:item.id,
        }
        axios.post(API.FRAMEEWORK_KNOWLEDGE_OFFLINE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('成功 次日生效')
                item.online_status = '3'

                const loop = (data,  callback) => {
                    data.forEach((item, index, arr) => {
                        callback(item, index, arr);
                        if (item.list) {
                            return loop(item.list,  callback);
                        }
                    });
                };
                if(item.list){
                    loop(item.list, (item1) => {
                        item1.online_status = '3'
                    });
                }

                let treeData = [...this.state.treeData]
                this.setState({treeData:treeData})
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //知识点详情
    detailKnowledge=(id,cb)=>{
        let data = {
            know_id:id,
        }
        axios.post(API.FRAMEEWORK_KNOWLEDGE_DETAIL, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({name:res.data.name,mark:res.data.mark,allow_repeat_question:res.data.allow_repeat_question||'0',knowType:res.data.know_type,visibleDetail:true,knowDetail:res.data})
                cb&&cb()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //删除知识点
    delKnowledge=(id)=>{
        let data = {
            know_id:id,
        }
        axios.post(API.FRAMEEWORK_KNOWLEDGE_DEL, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message)
                let treeData = [...this.state.treeData]
                let arr1=[],index1=0
                this.loop(treeData, id, (item,index,arr) => {
                    arr1=arr;index1 = index
                });
                arr1.splice(index1,1)
                this.setState({visibleEdit:false,treeData:treeData})
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }

    //树结构拖动
    onDragEnter = (info) => {
        // expandedKeys 需要受控时设置
        // this.setState({
        //   expandedKeys: info.expandedKeys,
        // });
    }
    loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
            if (item.id === key) {
                return callback(item, index, arr);
            }
            if (item.list) {
                return this.loop(item.list, key, callback);
            }
        });
    };
    onDrop = (info) => {
        const dropKey = info.node.props.eventKey;
        if(dropKey<0){return}
        const dragKey = info.dragNode.props.eventKey;
        const dropPos = info.node.props.pos.split('-');
        let move_type = 1//1前 2后 3中间
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
        // const dragNodesKeys = info.dragNodesKeys;

        const preTreeData = JSON.parse(JSON.stringify(this.state.treeData));
        const data = [...this.state.treeData];
        let dragObj;
        this.loop(data, dragKey, (item, index, arr) => {
            arr.splice(index, 1);
            dragObj = item;
        });
        if (info.dropToGap) {
            let ar;
            let i;
            this.loop(data, dropKey, (item, index, arr) => {
                ar = arr;
                i = index;
            });
            if (dropPosition === -1) {
                ar.splice(i, 0, dragObj);
                move_type = 1
            } else {
                ar.splice(i + 1, 0, dragObj);
                move_type = 2
            }
        } else {
            move_type = 3
            this.loop(data, dropKey, (item) => {
                item.list = item.list || [];
                if(item.pre_list&&item.pre_list.length){
                    message.error('此知识点拥有前置知识点，不可添加子知识点，请清除前置知识点后再试。')
                    this.setState({treeData:preTreeData})
                }
                // where to insert 示例添加到尾部，可以是随意位置
                item.list.push(dragObj);
            });
        }
        this.setState({
            treeData: data,
        });
        //move 知识点移动请求
        let postBody = {
                know_id:dragKey,
                move_type:move_type,
                target_know:dropKey,
                subject:this.props.user.subject,
                grade_part:this.props.user.grade_part
        }
        axios.post(API.FRAMEEWORK_KNOWLEDGE_MOVE, postBody).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message)
            }else{
                message.error(res.message)
                this.setState({treeData:preTreeData})
            }
        },()=>{message.error("网络错误！")})

    }
    onSelect = (selectedKeys, info) => {
        console.log('selected', selectedKeys, info);
    }

    //关掉多层（因设置expandedKeys后无法自动关掉多层）
    onTreeExpand=(expandedKeys,obj)=>{
        let expandedKeysSet = new Set(expandedKeys)
        if(!obj.expanded){

            //所有节点执行cb的loop
            const loopAll = (data, callback) => {
                data.forEach((item, index, arr) => {
                     callback(item, index, arr);
                    if(item.list) {
                        return loopAll(item.list, callback);
                    }
                });
            };
            this.loop(this.state.treeData, obj.node.props.eventKey, (item, index, arr) => {
                //目标节点下的所有节点从expandedKeys中移除
                item.list&&loopAll(item.list,(item1)=>{
                    expandedKeysSet.delete(item1.id)
                })
            });
        }
        this.setState({expandedKeys:[...expandedKeysSet],autoExpandParent: false,})

    }
    onSearch = () => {
        const value = this.state.search;
        //所有节点执行cb的loop
        const loopAll = (data, callback) => {
            data.forEach((item, index, arr) => {
                callback(item, index, arr);
                if(item.list) {
                    return loopAll(item.list, callback);
                }
            });
        };
        let expandedKeys = []
        let matchingSearch = new Set()

        let isHas = true
        loopAll(this.state.treeData,(item, index, arr)=>{
            if ((''+item.id).indexOf(value) > -1||item.name.indexOf(value) > -1) {
                expandedKeys.push(item.id)
                matchingSearch.add(item.id)
                isHas = false
            }
        })
        this.setState({expandedKeys,matchingSearch,autoExpandParent: true})
        if(isHas){
           message.error('查询无结果')
        }
    }


    //树结构的loop方法
    loopDom = (data,nextState) => {
        return data.map((item) => {
                return <TreeNode  title={<span style={nextState.matchingSearch.has(''+item.id)? {backgroundColor:'#fea',fontSize:13}:{fontSize:13}}>
                                            {item.know_type=='1'?
                                                <Tag color="#2db7f5" style={{marginRight:3}}>考点</Tag>:''
                                            }
                                            {item.name}
                                            {item.id>0?`(${item.id})`:''}
                                            {
                                                item.id>=0?
                                                <span style={{fontSize:14,color:'#000',marginLeft:5,fontWeight:'600'}}>
                                                {/*{*/}
                                                {/*    this.props.user.role_know&&this.props.user.role_know.add>0&&*/}
                                                {/*    <Tooltip title={'添加'} mouseEnterDelay={1}>*/}
                                                {/*        <Icon type="plus"  style={{marginLeft:5}} onClick={(e)=>{this.addKnow(e,item)}}/>*/}

                                                {/*    </Tooltip>*/}
                                                {/*}*/}
                                                {/*    {*/}
                                                {/*        this.props.user.role_know&&this.props.user.role_know.edit>0&&*/}
                                                {/*        <Tooltip title={'编辑'} mouseEnterDelay={1}>*/}
                                                {/*            <Icon type="edit"  style={{marginLeft:5}} onClick={(e)=>{this.openKnowEdit(e,item)}}/>*/}

                                                {/*        </Tooltip>*/}
                                                {/*    }*/}

                                                    {
                                                        this.props.user.role_know&&this.props.user.role_know.online>0&&
                                                        <Popconfirm title="确认上线吗？" onConfirm={(e) => {e.stopPropagation();this.onlineKnowledge(item,data)}} okText="确认" cancelText="取消">
                                                            <Tooltip title={'上线'} mouseEnterDelay={1}>
                                                                <Icon type="to-top"  style={{marginLeft:5}}/>
                                                            </Tooltip>
                                                        </Popconfirm>
                                                    }
                                                    {
                                                        this.props.user.role_know&&this.props.user.role_know.offline>0&&
                                                        <Popconfirm title="确认下线吗？" onConfirm={(e) => {e.stopPropagation();this.offlineKnowledge(item,data)}} okText="确认" cancelText="取消">

                                                            <Tooltip title={'下线'} mouseEnterDelay={1}>
                                                                <Icon type="arrow-down" style={{marginLeft:5}}/>
                                                            </Tooltip>
                                                        </Popconfirm>
                                                    }
                                                        <Tooltip title={'详情'} mouseEnterDelay={1}>
                                                                <Icon type="file-text" onClick={(e) => {e.stopPropagation();this.detailKnowledge(item.id)}} style={{marginLeft:5}}/>
                                                        </Tooltip>

                                                    {/*{*/}
                                                    {/*    this.props.user.role_know&&this.props.user.role_know.del>0&&*/}
                                                    {/*    <Popconfirm title="确认删除吗？" onConfirm={(e) => {e.stopPropagation();this.delKnowledge(item.id)}} okText="确认" cancelText="取消">*/}

                                                    {/*        <Tooltip title={'删除'} mouseEnterDelay={1}>*/}
                                                    {/*            <Icon type="delete"  style={{marginLeft:5}}/>*/}
                                                    {/*        </Tooltip>*/}
                                                    {/*    </Popconfirm>*/}
                                                    {/*}*/}
                                                    {
                                                        item.id>=0&&(
                                                            (item.online_status=='2')?
                                                                <Tag color="#87d068" style={{marginLeft:5}}>{ONLINESTATUS[item.online_status]}</Tag>
                                                                :
                                                                <Tag color="#f50" style={{marginLeft:5}}>{ONLINESTATUS[item.online_status]}</Tag>
                                                        )

                                                    }

                                            </span>  : null
                                            // <span style={{fontSize:14,color:'#000',marginLeft:5,fontWeight:'600'}}>
                                            //     {
                                            //         this.props.user.role_know&&this.props.user.role_know.add>0&&
                                            //         <Tooltip title={'添加'} mouseEnterDelay={1}>
                                            //             <Icon type="plus"  style={{marginLeft:5}} onClick={(e)=>{e.stopPropagation();this.setState({visibleAdd:true,addKnowType:item.type,addId:item.id,name:'',mark:'',knowType:'0',allow_repeat_question:'0'})}}/>
                                            //         </Tooltip>
                                            //     }
                                            // </span>
                                            }
                                        </span>}
                                  key={item.id}
                >
                    {
                        item.list && item.list.length&&
                        this.loopDom(item.list,nextState)
                    }
                </TreeNode>;
        });
    }


    render() {
        const token = storage.getData('token');
        //上传知识点树
        const props = {
            name: 'file',
            action: `${API.FRAMEEWORK_KNOWLEDGE_IMPORT}&token=${token}`,
            data:{
                subject:this.props.user.subject,
                grade_part:this.props.user.grade_part,
            },
            beforeUpload(file) {
                let xls = false
                if(file.type === ''){if(/.xls/.exec(file.name)){xls = true}}
                const notExcel = !(file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'||file.type === 'application/vnd.ms-excel'||xls);
                if(notExcel){
                    message.error('上传文件格式不是Excel')
                    return false
                }
            },

            onChange(info) {
                if (info.file.status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if (info.file.status === 'done') {
                    if(info.file.response.code === 0) message.success(`${info.file.name} 上传成功`);
                    else message.success(`${info.file.response.message}`);
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} 上传失败`);
                }
            },
        };

        return (
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>知识点&教辅管理</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:19}}>
                        <span>知识点</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{marginTop:15}}>
                    <Col span={24}>
                        <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}}>
                            <label style={{width:'80px',display:'inline-block'}} >关键字</label>
                            <Input
                                placeholder="输入关键字"
                                style={{ width: 180,marginRight:10}}
                                onChange={(e)=>this.setState({search:e.target.value})}
                                value={this.state.search}
                            />
                            <Button onClick={this.onSearch}>搜索</Button>
                        </div>
                        <div>
                            <Alert showIcon style = {{marginTop: '10px'}} type = "warning" message = "若移动节点操作无响应，请清除cookie或重启浏览器" closable />
                            <div>
                                {/*
                                <Button disabled = { true } onClick = { this.handleAddRootNode }>
                                    <i style={{fontSize: "12px", marginRight: '5px'}} className="iconfont icon-38xinzeng"></i>
                                    添加根节点
                                </Button>
                            */}
                                {
                                    this.props.user.role_know&&this.props.user.role_know.download&&
                                    <Button style={{marginLeft:20}} disabled={ !this.props.user.subject } onClick = { this.handleDownload }>
                                        下载知识点树
                                    </Button>
                                }
                                {/*   新版cms隐藏按钮   */}
                                {/*<Button style={{marginLeft:20}} onClick = { this.handleDownloadTemp }>*/}
                                {/*    下载知识点模板*/}
                                {/*</Button>*/}
                                {/*{*/}
                                {/*    this.props.user.role_know&&this.props.user.role_know.import&&*/}
                                {/*    <Upload*/}
                                {/*        {...props}*/}
                                {/*        showUploadList={false}*/}
                                {/*    >*/}
                                {/*        <Button style={{marginLeft:20}}>*/}
                                {/*            <Icon type="upload" /> 上传知识点*/}
                                {/*        </Button>*/}
                                {/*    </Upload>*/}
                                {/*}*/}
                            </div>

                            <Spin spinning = {this.state.loading}>
                                <div className={'knowledgeTree'}>
                                    <Tree
                                        showLine
                                        expandedKeys={this.state.expandedKeys}
                                        onSelect={this.onSelect}
                                        showIcon={false}
                                        onExpand={this.onTreeExpand}
                                        draggable={!!(this.props.user.role_know&&this.props.user.role_know.move)}
                                        onDragEnter={this.onDragEnter}
                                        onDrop={this.onDrop}
                                        autoExpandParent={this.state.autoExpandParent}
                                    >
                                        {this.treeNode.map(d=>d)}
                                        {/*更新卡顿*/}
                                        {/*{this.loopDom(this.state.treeData)}*/}
                                    </Tree>
                                </div>
                            </Spin>
                            <Modal
                                title={'添加节点'}
                                visible={ this.state.visibleAdd }
                                onOk={ this.addKnowledge }
                                onCancel={ ()=>{this.setState({visibleAdd:false})} }
                                okText = { '添加' }
                            >
                                    <Row className="row" >
                                        <Col span={2}>名称：</Col>
                                        <Col span={22}>
                                            <Input placeholder = "输入名称(必填)" value={this.state.name} onChange = { e => this.setState({name:e.target.value}) } />
                                        </Col>
                                    </Row>
                                    <Row className="row"  style={{marginTop:20}}>
                                        <Col span={2}>概要</Col>
                                        <Col span={22}>
                                            <Input placeholder = "输入概要(非必填)" value={this.state.mark} onChange = {  e => this.setState({mark:e.target.value}) } />
                                        </Col>
                                    </Row>
                                    <Row className="row"  style={{marginTop:20}}>
                                        <Col span={2}>类型</Col>
                                        <Col span={22}>
                                            <RadioGroup value={this.state.knowType} size="large" onChange={(e)=>{this.setState({knowType:e.target.value})}}>
                                                <RadioButton key={'0'} value={'0'} disabled={false}>知识点</RadioButton>
                                                <RadioButton key={'1'} value={'1'} disabled={false}>考点</RadioButton>
                                            </RadioGroup>
                                        </Col>

                                    </Row>

                                {
                                        (this.state.addKnowType==='0'||~~this.state.addId===-1000)&&
                                        <Row style={{marginTop:15}}>
                                            <Checkbox style={{marginLeft:20}} checked = { ~~this.state.allow_repeat_question } onChange = { (e)=>{this.setState({allow_repeat_question:~~e.target.checked})} }>允许同教材中出现该知识点的重题</Checkbox>

                                        </Row>
                                    }

                                    <Row className="row"  style={{marginTop:20}}>
                                        {
                                            this.state.isEndNode?
                                                <div>
                                                    {

                                                    this.state.select&&this.state.select.length&&
                                                    this.state.select.map((val,k)=>
                                                        <div key={k}>
                                                            <div>前置知识点：已选择{this.state.select[0].selected&&this.state.select[0].selected.length}个 <span style={{color:'#ccc',float:'right'}}>最多添加10个</span></div>
                                                            <Row key={k}>
                                                                <KnowledgeBox data={this.state.select[k]}
                                                                              select={this.state.select}
                                                                              historyData={[]}
                                                                              isTask={'noTask'}
                                                                              okCallBackData={{know_id:this.state.addId,URL:API.FRAMEEWORK_KNOWLEDGE_ADD_PRE,onOk:()=>{this.forceUpdate()},is_add:1}}
                                                                              canSelectParentNode={true}
                                                                              hideWell={true}
                                                                ></KnowledgeBox>
                                                            </Row>
                                                        </div>

                                                    )
                                                    }
                                                </div>

                                            :
                                                <div>
                                                    <div>前置知识点：<span style={{color:'#ccc'}}>仅末级知识点可选</span></div>
                                                </div>
                                        }
                                    </Row>
                            </Modal>
                            <Modal
                                title={'编辑节点'}
                                visible={ this.state.visibleEdit }
                                onOk={ this.editKnowledge }
                                onCancel={ ()=>{this.setState({visibleEdit:false})} }
                                okText = { '确定' }
                            >
                                <Row className="row" >
                                    <Col span={2}>名称：</Col>
                                    <Col span={22}>
                                        <Input placeholder = "输入名称(必填)" value={this.state.name} onChange = { e => this.setState({name:e.target.value}) } />
                                    </Col>
                                </Row>
                                <Row className="row"  style={{marginTop:20}}>
                                    <Col span={2}>概要</Col>
                                    <Col span={22}>
                                        <Input placeholder = "输入概要(非必填)" value={this.state.mark} onChange = {  e => this.setState({mark:e.target.value}) } />
                                    </Col>
                                </Row>
                                <Row className="row"  style={{marginTop:20}}>
                                    <Col span={2}>类型</Col>
                                    <Col span={22}>
                                        <RadioGroup value={this.state.knowType} size="large" onChange={(e)=>{this.setState({knowType:e.target.value})}}>
                                            <RadioButton key={'0'} value={'0'} disabled={false}>知识点</RadioButton>
                                            <RadioButton key={'1'} value={'1'} disabled={false}>考点</RadioButton>
                                        </RadioGroup>
                                    </Col>

                                </Row>
                                {
                                    (this.state.editKnowType==='0'||this.state.editId==='-1000')&&
                                    <Row style={{marginTop:15}}>
                                        <Checkbox style={{marginLeft:20}} checked = { ~~this.state.allow_repeat_question } onChange = { (e)=>{this.setState({allow_repeat_question:~~e.target.checked})} }>允许同教材中出现该知识点的重题</Checkbox>

                                    </Row>
                                }

                                <Row className="row"  style={{marginTop:20}}>
                                    {
                                        this.props.user.role_know&&this.props.user.role_know.addPre&&

                                        this.state.isEndNode?
                                            <div>
                                                {
                                                    this.state.select&&this.state.select.length&&
                                                    this.state.select.map((val,k)=>
                                                        <div key={k}>
                                                            <div>前置知识点：已选择{this.state.select[0].selected&&this.state.select[0].selected.length}个 <span style={{color:'#ccc',float:'right'}}>最多添加10个</span></div>
                                                            <Row key={k}>
                                                                <KnowledgeBox data={this.state.select[k]}
                                                                              select={this.state.select}
                                                                              historyData={[]}
                                                                              isTask={'noTask'}
                                                                              okCallBackData={{know_id:this.state.editId,URL:API.FRAMEEWORK_KNOWLEDGE_ADD_PRE,onOk:()=>{this.forceUpdate()},is_add :0}}
                                                                              canSelectParentNode={true}
                                                                              hideWell={true}
                                                                ></KnowledgeBox>
                                                            </Row>
                                                        </div>

                                                    )
                                                }
                                            </div>

                                            :
                                            <div>
                                                <div>前置知识点：<span style={{color:'#ccc'}}>仅末级知识点可选</span></div>
                                            </div>
                                    }
                                </Row>
                            </Modal>
                            <Modal
                                title={'知识点详情'}
                                visible={ this.state.visibleDetail }
                                onOk={ ()=>{this.setState({visibleDetail:false})} }
                                onCancel={ ()=>{this.setState({visibleDetail:false})} }
                                okText = { '确认' }
                            >
                                <Row className="row" key= {1}>
                                    <Col span={4}>名称：</Col>
                                    <Col span={20}>{ this.state.knowDetail.name }</Col>
                                </Row>
                                <Row className="row" key= {2}>
                                    <Col span={4}>ID：</Col>
                                    <Col span={20}>{ this.state.knowDetail.know_id }</Col>
                                </Row>
                                <Row className="row" key= {3}>
                                    <Col span={4}>概要：</Col>
                                    <Col span={20}>{ this.state.knowDetail.mark }</Col>
                                </Row>
                                <Row className="row" key= {4}>
                                    <Col span={4}>上线状态：</Col>
                                    <Col span={20}>{ ONLINESTATUS[this.state.knowDetail.online_status] || ONLINESTATUS[0] }</Col>
                                </Row>
                                <Row className="row" key= {5}>
                                    <Col span={4}>创建时间：</Col>
                                    <Col span={20}>{ this.state.knowDetail.create_time }</Col>
                                </Row>
                                <Row className="row" key= {6}>
                                    <Col span={4}>更新时间：</Col>
                                    <Col span={20}>{ this.state.knowDetail.update_time }</Col>
                                </Row>
                            </Modal>


                        </div>
                    </Col>
                </Row>



            </div>
        )
    }
}

function mapState(state) {
    return {
        user:state.user
    };
}

function mapDispatch(dispatch) {
    return{

    }
}
export default connect(mapState, mapDispatch)(DailyError);


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/knowledge/view.js